var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"crly-o-common-footer"},[_c('CMS',{attrs:{"contents_type":"block_contents","location_code":"CRLY_TOP_99_01-footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }